import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AppScriptGrid extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
	
		var appScriptGrid = this;
		setTimeout(function(){
			appScriptGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var systemUpdateGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_APP_SCRIPTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_APP_SCRIPTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'download',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_APP_SCRIPTS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download')						
					],
					listeners: {
						click: function() {
							actionDownload(grid.selectedItems[0]);
						}
					}					
				},		
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['ADMIN_APP_SCRIPTS:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'scriptId',
					header: 'Script Id',
					width: '7em'
				},
				{						
					path: 'name',
					header: 'Name',
					width: '7em'
				},
				{						
					path: 'outputTypeDescription',
					header: 'Output Type',
					width: '7em'
				},
				{						
					path: 'workingStatusDescription',
					header: 'Working Status',
					width: '7em'
				},				
				{						
					path: 'lastRunResultDescription',
					header: 'Run Results',
					width: '7em'
				},
				{						
					path: 'lastResultsFileId',
					header: 'Output File',
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;	
						
						if (item.lastResultsFileId) {
							ElementUtil.query(toolbar, 'download').disabled = false;
						} else {
							ElementUtil.query(toolbar, 'download').disabled = true;
						}
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
						ElementUtil.query(toolbar, 'download').disabled = true;						
					}
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		systemUpdateGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			var loadMask = grid.showLoading();
			
			Service.getAppScriptService().getAppScripts().then(function(scripts){
				loadMask.remove();
				grid.activeItem = null;
				grid.items = scripts.data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var parameters = [];
						var parameterGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [								
								{						
									path: 'key',
									header: 'Key',					
									width: '9em'
								},								
								{
									path: 'value',
									header: 'Value',
									width: '9em'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									parameterGrid.selectedItems = item ? [item] : [];
									if (parameterGrid.selectedItems.length > 0) {											
										ElementUtil.query(formPanel, 'editParameter').disabled = false;										
										ElementUtil.query(formPanel, 'removeParameter').disabled = false;										
									} else {	
										ElementUtil.query(formPanel, 'editParameter').disabled = true;										
										ElementUtil.query(formPanel, 'removeParameter').disabled = true;
									}	
								}
							}
						});					
						
						var topToolbar = null;						
						if (record) {
							topToolbar = ElementUtil.create({
								tag: 'dl-toolbar',
								slot: 'toolbar',
								theme: 'spacing',
								children: [							
									{
										tag: 'dl-action-button',									
										theme: 'primary',
										'class': 'spacer-toolbar-item',
										permissions: ['ADMIN_APP_SCRIPTS:EXECUTE'],
										children: [
											ElementUtil.makeIcon('vaadin:play', 'Save And Run')
										],
										listeners: {
											click: function () {
												actionRunScript(false);
											}
										}
									},
									{
										tag: 'div',
										style: 'float: right;',
										children: [
											{
												tag: 'dl-action-button',
												theme: 'secondary',												
												'class': 'spacer-toolbar-item',
												style: 'float: right;',
												permissions: ['ADMIN_APP_SCRIPTS:EXECUTE'],
												children: [
													ElementUtil.makeIcon('vaadin:play-circle', ' Save And Run Background')
												],
												listeners: {
													click: function () {
														actionRunScript(true);
													}
												}
											}
										]
									}
								]							
							});
						}
												
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							slot: 'primary',
							style: 'display: block; width: 99%;',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'name',
											label: 'Name',											
											required: true,
											maxLength: 255											
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Output Type', 
											name: 'outputType',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,											
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('AppScriptOutputType').then(function(data){
													combo.items = data;
													if (!record) {
														combo.value = 'TXT';
													}
												});
											}									
										},										
										{
											tag: 'vaadin-text-area',										
											name: 'script',
											label: 'Script',
											style: 'max-height: 400px;',										
											colspan: 2,
											maxLength: 1000000												
										},
										{
											tag: 'dl-section-title',
											title: 'Parameters',
											colspan: 2,
											style: 'margin-top: 20px;'											
										},
										{
											tag: 'div',
											style: 'height: 350px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [														
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',																	
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditParameter();
																		}
																	}					
																},	
																{
																	tag: 'vaadin-button',
																	itemid: 'editParameter',																	
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:edit', ' Edit')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditParameter(parameterGrid.selectedItems[0]);
																		}
																	}					
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'removeParameter',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemoveParameter(parameterGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														parameterGrid													
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																														
															formPanel.submitForm({
																preSubmit: function (data) {																	
																	var saveModel = createSaveModel(data);																	
																	return saveModel;
																},
																actualCall: function (data) {
																	if (record) {
																		data.scriptId = record.scriptId;
																	}
																	return Service.getAppScriptService().saveAppScript(data, (record ? true : false));
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved System Update', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Close',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});									
												
						if (record) {
							var scriptFlexLayout = ElementUtil.create({
								tag: 'dl-flex-layout',
								children: [
									topToolbar,
									formPanel
								]
							});							
							addEditWin.addToContentElement(scriptFlexLayout);
						} else {
							addEditWin.addToContentElement(formPanel);
						}
						
						var actionRefreshParameter = function() {														
							parameterGrid.activeItem = null;
							parameterGrid.items = parameters.slice(0);	
						};						
						
						if (record) {	
							
							var loadMask = formPanel.showLoading();
							Service.getAppScriptService().getAppScript(record.scriptId).then(function(fullModel){
								loadMask.remove();
								
									//load full model							
								var loadModel = {
									name: fullModel.appScriptMetaData.name,
									outputType: fullModel.appScriptMetaData.outputType,
									script: fullModel.appScript.script
								};

								formPanel.load(loadModel);	

								if (fullModel.appScript.parameters) {
									for (var key in fullModel.appScript.parameters) {
										parameters.push({
											key: key,
											value: fullModel.appScript.parameters[key]
										});
									}
								}							
								actionRefreshParameter();
								
							}, function(){
								loadMask.remove();
							});							
							
						}
						
						var actionRemoveParameter = function(param) {
							var newItems = [];
							parameters.forEach(function(item){
								if (!(item.key === param.key)) {
									newItems.push(item);
								}
							});	
							parameters = newItems;
							actionRefreshParameter();
						};
						
						var actionAddEditParameter = function(param) {
							
							var addEditParamWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: param ? 'Edit' : 'Add',
								icon: 'vaadin:edit',
								width: 600,
								height: 400,
								listeners: {
									ready: function () {
										addEditParamWin.show();									
																		
										var paramFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [																												
														{
															tag: 'vaadin-text-field',
															name: 'key',
															label: 'Key',																
															maxLength: 255
														},														
														{
															tag: 'vaadin-text-field',
															name: 'value',
															label: 'Value',																
															maxLength: 255
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', (param ? ' Update' : ' Add'))
																	],
																	listeners: {
																		click: function() {															

																			var data = paramFormPanel.getData();
																							
																			//add record
																			if (!param) {																				
																				parameters.push(data);																			
																			} else {
																				param.key = data.key;
																				param.value = data.value;																		
																			}
																			
																			//refresh rules
																			actionRefreshParameter();
																			addEditParamWin.close();
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addEditParamWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});			

										addEditParamWin.addToContentElement(paramFormPanel);
										
										
										if (param) {
											paramFormPanel.load(param);											
										}
										
									}
								}
							});
							
						};	
						
						
						var createSaveModel = function(data) {							
							var saveModel = {
								appScriptMetaData: {
									name: data.name,
									outputType: data.outputType
								},
								appScript: {
									script: data.script,
									parameters: {
									}
								}
							};

							if (parameters) {
								parameters.forEach(function (param) {
									saveModel.appScript.parameters[param.key] = param.value;
								});
							}
							return saveModel;
						};
						
						var actionRunScript = function(background) {
							if (background) {
								
								var saveModel = createSaveModel(formPanel.getData());
								var loadMask = formPanel.showLoading('Running...');
								Service.getAppScriptService().runScriptAsync(record.scriptId, saveModel).then(function(results){
									loadMask.remove();
									
									window.DL.MessageUtil.showToast('Success', 'Submmited Script to run in the background', {
										theme: 'success',
										position: 'top-stretch'
									});
									actionRefresh();
									addEditWin.close();									
									
								}, function(){
									loadMask.remove();									
								});
								
							} else {
								var resultsWin = ElementUtil.create({
									tag: 'dl-dialog',
									title: 'Results',
									icon: 'vaadin:edit',
									width: .65,
									height: .65,
									listeners: {
										ready: function () {
											resultsWin.show();	
																						
											var resultsArea = ElementUtil.create({
												tag: 'vaadin-text-area',
												slot: 'primary',
												itemId: 'resultsArea',
												name: 'output',
												label: 'output',
												style: 'width: 100%; height: 95%;'
											});
											
											resultsWin.addToContentElement(resultsArea);
											
											var saveModel = createSaveModel(formPanel.getData());
											var loadMask = resultsArea.showLoading('Running...');
											Service.getAppScriptService().runScriptSync(record.scriptId, saveModel).then(function(results){
												loadMask.remove();
												
												var allResults = results.output;	
												if (results.errors && results.errors !== '') {
													allResults += '\n\nErrors: \n' + results.errors;
												}																	
												
												resultsArea.value = allResults;
												actionRefresh();
												
											}, function(){
												loadMask.remove();												
											});
										}
									}
								});
							}
						};
						
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.name + '"?</b>',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							Service.getAppScriptService().deleteScript(record.scriptId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
		var actionDownload = function(record) {
			Service.getAppScriptService().downloadOutput(record.scriptId);
		};
		
	}
	
}
customElements.define('dl-appscript-grid', AppScriptGrid);


